package math

import com.github.chosamuel.kishibe.math.Vector2

fun Vector2.lerp(v: Vector2, f: Double): Vector2 = this.minus(v).times(f).plus(v)
